var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nda-article',{attrs:{"bannerSrc":_vm.isTenant ? require('../assets/panda/receta.svg') : require('../assets/receta.svg'),"description":_vm.description,"image":_vm.image,"name":_vm.name,"sectionName":"Recetas"}})
}
var staticRenderFns = []

export { render, staticRenderFns }